<template>
    <div class="viewport">
        <md-list style="padding-top: 0">
            <md-list-item v-for="item in items" :key="item.code">
                <!-- vue-material: the checked state is the `model` prop (what v-model binds),
                     `value` is only the html value attribute. -->
                <md-switch :model="isChecked(item.code)" @change="checked => setChecked(item.code, checked)" />
                <span class="md-list-item-text">{{ item.name }}</span>
            </md-list-item>
        </md-list>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IWorkOrderChecklistItemEntity, IWorkOrderEntity } from '@phrospr/lib-models';

// The checklist of the work order's type (resolved by the parent from the tenant's catalogue).
// Only what the technician ticks is written here; on save the backend fills in the untouched
// items of the checklist as false and drops anything that does not belong to it.
@Component({})
export default class WorkOrderTypeAdditionalChecks extends Vue {
    @Prop() private workOrderUpsert!: IWorkOrderEntity;
    @Prop({ default: () => [] }) private items!: IWorkOrderChecklistItemEntity[];

    isChecked(code: string): boolean {
        return this.workOrderUpsert.data.additional_checks?.[code] === true;
    }

    setChecked(code: string, checked: boolean) {
        // Vue 2 only tracks keys that exist at assignment time: $set keeps new keys reactive.
        if (!this.workOrderUpsert.data.additional_checks) {
            this.$set(this.workOrderUpsert.data, 'additional_checks', {});
        }
        this.$set(this.workOrderUpsert.data.additional_checks, code, checked === true);
    }
}
</script>

<style lang="scss" scoped>
::v-deep .md-list-item-content {
    min-height: 20px !important;
}
.md-list-item-content > .md-switch {
    margin: 0;
    margin-right: 22px;
}
.md-list-item-text {
    white-space: normal;
}
</style>
